import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const userPhotoStyles = makeStyles()((_theme: Theme) => ({
  photoRoot: {
    position: 'relative',
    cursor: 'pointer',
    flexShrink: 0,
  },
  photoContainer: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    background: `linear-gradient(180deg, ${_theme.palette.primary.main} 0%, ${_theme.palette.primary.main} 20%, ${_theme.palette.secondary.main} 80%, ${_theme.palette.secondary.main} 100%)`,
    padding: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoInner: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#f5f3f7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img, & svg': {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      objectFit: 'cover',
    },
  },
  avatar: {
    background: _theme.palette.primary.main,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 700,
    fontFamily: 'Inter, sans-serif',
    letterSpacing: '-0.01em',
    flexShrink: 0,
    cursor: 'pointer',
  },
  avatarSmall: {
    width: '40px',
    height: '40px',
    fontSize: _theme.typography.body1.fontSize,
  },
  avatarMedium: {
    width: '52px',
    height: '52px',
    fontSize: _theme.typography.h6.fontSize,
  },
}));
